var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"mb-1 p-0"},[_c('shedule-title')],1)],1),_c('b-row',[_c('b-col',{staticClass:"mb-1 mt-4 p-0 ml-2 mr-2 ml-xl-0"},[_c('shedule-docs')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }